import cx from 'classnames';
import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import { Button } from './button';
import { WhatsappIcon } from './icon/whatsapp-icon';
import { useLocalize } from './localize-context';
import styles from './message-btn.module.scss';
import { OutLink } from './outlink';

type MessageBtnProps = {
  message: string;
  disabled: boolean;
  onClick?: () => void;
};

export const MessageBtn = (props: MessageBtnProps) => {
  const localize = useLocalize();
  const { prismicFooter } = useStaticQuery(query);

  return (
    <Button
      className={cx(
        'text-gray-100',
        props.disabled ? 'bg-gray-400 cursor-not-allowed' : styles.btn
      )}
      renderContainer={({ className }) => (
        <OutLink
          to={`https://wa.me/${
            prismicFooter.data.whatsapp.text
          }?text=${encodeURIComponent(props.message)}`}
          onClick={
            props.disabled
              ? ev => {
                  ev.preventDefault();
                }
              : props.onClick
          }
          className={className}
        >
          {localize('Book')}
          <WhatsappIcon
            className="ml-2"
            backgroundColor={props.disabled ? '#9fa6b2' : undefined}
          />
        </OutLink>
      )}
    />
  );
};

const query = graphql`
  {
    prismicFooter {
      data {
        whatsapp: whatsapp_number {
          text
        }
      }
    }
  }
`;
